import DownloadIcon from '@mui/icons-material/Download';
import { DialogContent, styled } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { recruitApi } from 'src/service';
import { getFileType } from 'src/utils/fileUploadUtils';

import { IRecruitDownladProps } from './RecruitFormDialog';

// 허용된 파일 타입 정의
const ACCEPTED_FILE_TYPES = {
  'image/*': ['.jpeg', '.jpg', '.png', '.gif', '.webp'],
  'application/pdf': ['.pdf'],
  'application/zip': ['.zip'],
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'application/vnd.ms-powerpoint': ['.ppt'],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'],
};
interface IDownloadDialogProps {
  data: IRecruitDownladProps;
}

// file이름 추출: /upload/recruit/yyyy/mm/dd/를 제거하고 "_"로 구분된 파일 이름 반환
function extractFileName(filePath: string): string {
  // 정규식을 사용하여 "/upload/recruit/yyyy/mm/dd/"를 제거
  const regex = /\/upload\/recruit\/\d{4}\/\d{2}\/\d{2}\//;
  const cleanedPath = filePath.replace(regex, '');

  // "_"로 구분하고, 나머지 부분 반환
  const parts = cleanedPath.split('_');
  if (parts.length > 1) {
    return parts.slice(1).join('_');
  }
  return cleanedPath;
}

export const DownloadDialog = observer(({ data }: IDownloadDialogProps) => {
  // 지원서 다운로드
  const handleDownload = async (filePath: string, index: number) => {
    const isZipFile = getFileType(data.filePath[index], ACCEPTED_FILE_TYPES).type === 'zip';
    try {
      const attachment = {
        recruitSid: data.recruitSid,
        fileNm: `${data.fileNm} - ${filePath}`,
        filePath: data.filePath[index],
        isZipFile: isZipFile,
      };
      await recruitApi.downloadFile(attachment);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <DialogContent dividers sx={{ pt: '10px' }}>
      {data.filePath.map((filePath, index) => {
        return (
          <DownloadItemContainer onClick={() => handleDownload(filePath, index)} key={index}>
            <Text>{extractFileName(filePath)}</Text>
            <DownloadIcon style={{ width: 18, height: 18 }} />
          </DownloadItemContainer>
        );
      })}
    </DialogContent>
  );
});

const DownloadItemContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: 2,
  justifyContent: 'space-between',
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: theme.spacing(0.5),
  padding: theme.spacing(2),
  alignItems: 'center',
  cursor: 'pointer',
}));
const Text = styled('a')(({ theme }) => ({
  cursor: 'pointer',
  fontSize: '16px',
  lineHeight: '16px',
  fontWeight: 600,
}));
